import React, { useState, useEffect, useMemo, useContext } from 'react';
import BreadCrumbs from '../../../../../Core/Controls/Breadcrumb';
import formatters from '../../../../../Core/Grid/inputFormatter';
import MananageAccountGrid from '../../../../managementAccount/manageAccountGrid';
import DialogComp from '../../../../../Core/Modal/dialogModal';
import { Grid } from '@material-ui/core';
import ReactDOM from 'react-dom';
import UpdateDescription from './updateDescription';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Management Accounts', active: true },
    { name: 'Nominal Departments', active: true }
];
const basecolumns = [
    { field: 'costCentre', title: 'Cost Centre', width: 100 },
    { field: 'shortName', title: 'Short Name', width: 120 },
    { field: 'kerridgeDesc', title: 'Department Code Description', width: 300 },
    { field: 'maDepartmentDescription', title: 'Management Account Description', width: 250 },
    { field: 'costCentreGroup', title: 'Cost Centre Group', width: 200 },
    { field: 'divisionDescription', title: 'Division Description', width: 150 },
    { field: 'lastUpdated', title: 'Last Updated', renderer: formatters.DateTimeFormatter, width: 200 }
];
const NominalDept = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let ParamDivisionCode = params.get('divisionCode') || '';

    const [state, setState] = useState({
        gridUrl: `NominalDepartmentCodes/NominalDepartmentCodes_List`,
        selectedRecord: null,
        isPopupModal: false,
        isReload: '',
        selectedColumnName: ''
    });

    useEffect(() => {
        if (ParamDivisionCode) {
            setState((st) => ({ ...st, gridUrl: `NominalDepartmentCodes/NominalDepartmentCodes_List?divisionCode=${ParamDivisionCode}` }));
        }
    }, [ParamDivisionCode]);

    const closeModal = (isReload) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.isPopupModal = false;
            newSt.selectedRecord = null;
            if (isReload) {
                newSt.isReload = new Date();
            }
            return newSt;
        });
    };

    const openModal = (record, columnName) => {
        const [code, description] =
            columnName === 'costCentreGroup' ? record.costCentreGroup.split(/-(.+)/).map((s) => s.trim()) : [record.costCentre, record.maDepartmentDescription];

        const selectedRecord = {
            code,
            keyloopDesc: columnName === 'costCentre' ? record.kerridgeDesc : record.kerridgeGroupDesc,
            description
        };

        setState((st) => ({
            ...st,
            isPopupModal: true,
            selectedRecord,
            selectedColumnName: columnName
        }));
    };

    const CostCenterColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => openModal(record, 'costCentre')}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const CostGroupCenterColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => openModal(record, 'costCentreGroup')}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const column = useMemo(() => {
        let col = [...basecolumns];
        let colAccCode = col.find((m) => m.field === 'costCentre');
        if (colAccCode) {
            colAccCode.renderer = CostCenterColumnWrapper;
        }
        let colAccGrpCode = col.find((m) => m.field === 'costCentreGroup');
        if (colAccGrpCode) {
            colAccGrpCode.renderer = CostGroupCenterColumnWrapper;
        }

        return col;
    }, [ParamDivisionCode]);

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />
            <MananageAccountGrid
                columns={column}
                getUrl={state.gridUrl}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
            />

            {state.isPopupModal && (
                <DialogComp title="Update Cost Centre Description" onClose={() => closeModal(false)} maxWidth="md" fullWidth overflow="auto">
                    <UpdateDescription selectedRecord={state.selectedRecord} selectedColumnName={state.selectedColumnName} onClose={closeModal} />
                </DialogComp>
            )}
        </div>
    );
};

export default NominalDept;
